import { Module } from 'vuex';

import { RootState } from '@/store';
import { chartsService } from '@/services/charts/charts.service';
import { Chart } from '@/services/charts/charts.types';
import { Statement } from '@/services/statements/statements.types';

export interface ChartsState {
  chart: Chart;
  chartLoading: boolean;
}

const state: ChartsState = {
  chart: null,
  chartLoading: false
};

const options: Module<ChartsState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    getChart: ({ commit, dispatch }, chartId): Promise<void> => {
      commit('chartLoading', true);
      return chartsService
        .get(chartId)
        .then(chart => commit('chart', chart))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('chartLoading', false));
    },
    createChart: ({ commit, dispatch }, chart: Chart): Promise<void> => {
      commit('chartLoading', true);
      return chartsService
        .create(chart)
        .then(chart => commit('chart', chart))
        .then(() => dispatch('alert/pushSuccess', 'Chart créée avec succes !', { root: true }))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('chartLoading', false));
    },
    updateChart: ({ commit, dispatch }, chart: Chart): Promise<void> => {
      commit('chartLoading', true);
      return chartsService
        .update(chart.id, chart)
        .then(chart => chart && commit('chart', chart))
        .then(() => dispatch('alert/pushSuccess', 'Chart modifiée avec succes !', { root: true }))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('chartLoading', false));
    },
    getChartByStatement: ({ commit, dispatch }, statement: Statement): Promise<void> => {
      commit('chartLoading', true);
      return chartsService
        .getByStatement(statement.id)
        .then(chart => commit('chart', chart))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('chartLoading', false));
    },
    updateChartFile: (
      { commit, dispatch },
      { chart, file }: { chart: Chart; file: Record<string, File> }
    ): Promise<void> => {
      commit('chartLoading', true);
      return chartsService
        .updateFile(chart.id, file)
        .then(chart => commit('chart', chart))
        .then(() => dispatch('alert/pushSuccess', 'Chart mise à jour !', { root: true }))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('chartLoading', false));
    },
    clearChart({ commit }): void {
      commit('chart', null);
    }
  },
  mutations: {
    chart: (state: ChartsState, chart: Chart) => (state.chart = chart),
    chartLoading: (state: ChartsState, chartLoading: boolean) => (state.chartLoading = chartLoading)
  }
};

export default options;
